(() => {
  if (window.__hfSchmitterDrawerOnlyV1) return;
  window.__hfSchmitterDrawerOnlyV1 = true;

  const FORM_SELECTOR = '[data-hf-buy-form]';

  const num = (value, fallback = 0) => {
    const parsed = Number(String(value ?? '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const fmt = value => {
    const n = num(value, 0);
    return Number.isInteger(n) ? String(n) : String(n).replace('.', ',');
  };

  const unitLabel = unit => {
    const u = String(unit || '').trim().toUpperCase();
    const labels = {
      STK: 'Stk.',
      PCE: 'Stk.',
      C62: 'Stk.',
      M: 'm',
      MTR: 'm',
      KGM: 'kg',
      KG: 'kg',
      LTR: 'l',
      L: 'l'
    };
    return labels[u] || String(unit || 'Stk.');
  };

  const waitForActions = async () => {
    for (let attempt = 0; attempt < 80; attempt++) {
      const actions = window.Shopify?.actions;

      if (
        actions &&
        typeof actions.updateCart === 'function' &&
        typeof actions.openCart === 'function'
      ) {
        return actions;
      }

      await new Promise(resolve => setTimeout(resolve, 50));
    }

    return null;
  };

  const setButtonBusy = (form, busy, success = false) => {
    const button = form.querySelector(
      'button[type="submit"], input[type="submit"]'
    );

    if (!button) return;

    if (busy) {
      if (!button.dataset.hfOriginalText) {
        button.dataset.hfOriginalText =
          button.tagName === 'INPUT'
            ? String(button.value || '')
            : String(button.textContent || '');
      }

      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      const label = success ? 'Hinzugefügt' : 'Wird hinzugefügt …';

      if (button.tagName === 'INPUT') {
        button.value = label;
      } else {
        button.textContent = label;
      }

      return;
    }

    if (
      button.dataset.hfRequestDisabled === 'true' ||
      form.dataset.hfRequestPrice === 'true'
    ) {
      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-disabled');

    const original = button.dataset.hfOriginalText;
    if (original !== undefined) {
      if (button.tagName === 'INPUT') {
        button.value = original;
      } else {
        button.textContent = original;
      }
      delete button.dataset.hfOriginalText;
    }
  };

  const syncCheckoutTotalProperty = (
    form,
    physical,
    factor,
    unit
  ) => {
    let input = form.querySelector(
      'input[name="properties[Gesamtmenge]"]'
    );

    if (factor !== 1) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Gesamtmenge]';
        input.setAttribute('data-hf-checkout-total-qty', '');
        form.appendChild(input);
      }

      input.value =
        fmt(physical) + ' ' + unitLabel(unit);
    } else if (input) {
      input.remove();
    }
  };

  const lineAttributes = form => {
    const result = [];

    form.querySelectorAll('input[name^="properties["]').forEach(input => {
      const match = String(input.name || '').match(/^properties\[(.*)\]$/);
      if (!match) return;

      result.push({
        key: match[1],
        value: String(input.value ?? '')
      });
    });

    return result;
  };

  document.addEventListener(
    'submit',
    async event => {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      const form = target?.closest(FORM_SELECTOR);
      if (!(form instanceof HTMLFormElement)) return;

      /*
       * Nur die dynamischen Schmitter-Finder-Formulare.
       * Native Horizon-Produktformulare bleiben komplett unangetastet.
       */
      if (form.dataset.hfAdding === '1') {
        event.preventDefault();
        return;
      }

      const submitButton = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );

      /*
       * "Preis auf Anfrage" bleibt gesperrt.
       * Der bestehende Sicherheitsblock darf dadurch nicht umgangen werden.
       */
      if (
        form.dataset.hfRequestPrice === 'true' ||
        submitButton?.dataset.hfRequestDisabled === 'true'
      ) {
        event.preventDefault();
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      const cartQtyInput = form.querySelector('[data-hf-cart-qty]');
      const physicalInput = form.querySelector('[data-hf-physical-qty]');

      if (!variantInput || !cartQtyInput || !physicalInput) return;

      const factor = num(
        form.querySelector('input[name="properties[_hf_order_factor]"]')?.value,
        1
      );

      const min = num(
        form.querySelector('input[name="properties[_hf_physical_min]"]')?.value,
        factor
      );

      const step = num(
        form.querySelector('input[name="properties[_hf_physical_step]"]')?.value,
        factor
      );

      const unit = String(
        form.querySelector('input[name="properties[_hf_unit]"]')?.value ||
        'STK'
      );

      const physical = num(physicalInput.value, min);

      const relative = (physical - min) / step;
      const validStep =
        step > 0 &&
        Math.abs(relative - Math.round(relative)) < 0.000001;

      /*
       * Ungültige Eingaben überlassen wir dem bereits vorhandenen
       * Finder-Validator. Er zeigt die bekannte Hinweismeldung.
       */
      if (
        !(factor > 0) ||
        !(min > 0) ||
        !(step > 0) ||
        physical < min ||
        !validStep
      ) {
        return;
      }

      const cartQty = physical / factor;

      if (
        cartQty < 1 ||
        Math.abs(cartQty - Math.round(cartQty)) > 0.000001
      ) {
        return;
      }

      /*
       * Ab hier ist die Menge gültig:
       * Browser-Navigation zu /cart/add unterbinden.
       */
      event.preventDefault();

      const finalCartQty = Math.round(cartQty);
      cartQtyInput.value = String(finalCartQty);

      syncCheckoutTotalProperty(
        form,
        physical,
        factor,
        unit
      );
      form.dataset.hfAdding = '1';
      setButtonBusy(form, true, false);

      try {
        const actions = await waitForActions();

        if (!actions) {
          throw new Error(
            'Der aufklappbare Warenkorb ist noch nicht vollständig geladen.'
          );
        }

        const result = await actions.updateCart(
          {
            lines: [
              {
                merchandiseId: String(variantInput.value),
                quantity: finalCartQty,
                attributes: lineAttributes(form)
              }
            ]
          },
          {
            event: {
              context: 'product',
              detail: {
                source: 'hydroflex-schmitter-finder'
              }
            }
          }
        );

        const errors = Array.isArray(result?.userErrors)
          ? result.userErrors
          : [];

        if (errors.length) {
          throw new Error(
            errors
              .map(error => error?.message)
              .filter(Boolean)
              .join(' · ') ||
            'Der Artikel konnte nicht hinzugefügt werden.'
          );
        }

        setButtonBusy(form, true, true);

        /*
         * updateCart aktualisiert den Drawer über das Theme-Event.
         * openCart stellt zusätzlich sicher, dass er sichtbar wird.
         */
        await actions.openCart();
      } catch (error) {
        console.error('[Hydroflex Schmitter → Cart Drawer]', error);

        alert(
          error?.message ||
          'Der Artikel konnte nicht zum Warenkorb hinzugefügt werden.'
        );
      } finally {
        delete form.dataset.hfAdding;

        setTimeout(() => {
          setButtonBusy(form, false);
        }, 450);
      }
    },
    true
  );
})();